import styled from 'styled-components';
import Color from 'color';

export default styled.button`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: .5rem 1rem;
  color: #fff;
  background-color: ${props => Color(props.theme.accentColor).alpha(.88).toString()};

  font-size: 1rem;
  border: none;
  outline: none;
  cursor: pointer;
`;
